import React from 'react';
import { Text } from '@mindbaz/ui-v2';
import { i18n } from '@lingui/core';
import { uniqueId } from 'lodash';

import { StyledTitle, Container, SpanColor } from './styledComponents';

const TitleDescriptionBlock = ({
  title,
  description,
  moreDescription,
  values,
}: {
  title: string;
  description: string;
  moreDescription?: React.ReactNode;
  values?: string;
}) => {
  const descriptionMessage = i18n._(description, { values });

  const renderWithBold = (msg: string) => {
    const parts = msg.split(/<strong>(.*?)<\/strong>/);
    return (
      <>
        {parts.map((part, i) =>
          i % 2 === 1 ? <SpanColor key={uniqueId()}>{part}</SpanColor> : part
        )}
      </>
    );
  };

  return (
    <Container>
      <StyledTitle variant="h1" weight="bold">{i18n._(title)}</StyledTitle>
      <Text>
        {renderWithBold(descriptionMessage)} {moreDescription}
      </Text>
    </Container>
  );
};

export default TitleDescriptionBlock;
